import React from 'react';
import { AnimatedPage } from '@/components/AnimatedPage';

export const TVPage = () => {
	return <AnimatedPage>TVPage</AnimatedPage>;
};
